const BASE_URL = process.env.BASE_URL || "/";

export const excelTemplate = {
  TEACHER_UPLOAD_TEMPLATE: BASE_URL + 'static/excel-template/teacher-upload-template.xlsx',
  STUDENT_UPLOAD_TEMPLATE: BASE_URL + 'static/excel-template/student-upload-template.xlsx',
  STUDENT_ENROLL_UPLOAD_TEMPLATE: BASE_URL + 'static/excel-template/student-enroll-upload-template.xlsx',
  EXAM_UPLOAD_TEMPLATE: BASE_URL + 'static/excel-template/exam-upload-template.xlsx',
};
